import React, {useEffect, useState} from 'react'
import AddOrRemoveFavouriteBox from '../AddOrRemoveFavouriteBox/AddOrRemoveFavouriteBox'
import SupplicerRetingAndName from './../SupplicerRetingAndName/SupplicerRetingAndName'
import SupplierAvatar from './../SupplierAvatar/SupplierAvatar'
import SupplierTop from './../SupplierTop/SupplierTop'
import './SupplierCard.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import SupplierDetails from './../SupplierDetails/SupplierDetails'
import { getResponseError } from '../../../../Api/Utils/apiUtils'
import EventApi from '../../../../Api/EventApi'


const SupplierCard = ({supplierInfo, customerId}) => {
    const [supplier, setsupplier] = useState(null)
    const [customer, setcustomer] = useState(null)

    const addToFavouriteList = async (supplier, customer) => {
        const addtoList = await EventApi.addOrRemovefavoriteSupplierList(customer, supplier, "i")
        const addToListApiError = getResponseError(addtoList)
        if (!addToListApiError) {
            window.location.reload()
        }
    }
    const removeFromFavoriteList = async (supplier, customer) => {
        const removetoList = await EventApi.addOrRemovefavoriteSupplierList(customer, supplier, "d")
        const removeToListApiError = getResponseError(removetoList)
        if (!removeToListApiError) {
            window.location.reload()
        }
    }

    useEffect(() => {
        setsupplier(supplierInfo)
        setcustomer(customerId)
    }, [customerId, supplierInfo])
    
    return ( 
        <>
            {supplier &&
            <div className="each-supplier-card">
                <SupplierTop>
                    <SupplierAvatar avatar={supplier.businessLogo ? supplier.businessLogo.imageUrl : `./img/avatar.png`} />
                    
                    <SupplicerRetingAndName supplierName={supplier.businessName} ID={supplier.userId} reting={supplier.rating} />
                    <AddOrRemoveFavouriteBox heartColor={supplier.isFavorite ? "#ff3955" : "#7e7d7d" }>
                        {supplier.isFavorite ?
                        <FontAwesomeIcon onClick={() => removeFromFavoriteList(supplier.id, customer)} icon={faHeart} />
                        :
                        <FontAwesomeIcon onClick={() => addToFavouriteList(supplier.id, customer)} icon={faHeart} />}
                    </AddOrRemoveFavouriteBox>
                </SupplierTop>
                <SupplierDetails name={supplier.businessName} lat={supplier.businessLatitude} lng={supplier.businessLongitude} email={supplier.emailAddress} phone={supplier.mobileNumber} address={supplier.businessAddress} />
            </div>}
        </>
    )
}

export default SupplierCard
